import { call, put } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';
import type { TalentProfileType } from '@ziynx/flow-types/talentProfile';

type GetProfileAction = {
  id?: string,
};

export function* getProfile(action: GetProfileAction): Generator<any, void, empty> {
  const talentId = action?.id ?? 'me';
  try {
    const response: TalentProfileType = yield call(() => APIService.apiRequest('GET_PROFILE', 'GET', {
      routeParams: {
        id: talentId,
      },
      query: {
        paginateResponses: 'true',
      },
      authorization: 'optional',
    }));
    yield put({
      type: ActionTypes.profile.get.SUCCESS,
      id: talentId,
      response,
    });
  } catch (error) {
    if (error?.status === 403 && !action?.retry) {
      yield put({
        type: ActionTypes.profile.get.START,
        retry: true,
      });
    }

    yield put({
      type: ActionTypes.profile.get.ERROR,
      error,
    });
  }
}

export function* getProfileResponses(action): Generator<any, void, empty> {
  const talentId = action?.id ?? 'me';
  try {
    const response: TalentProfileType = yield call(() => APIService.apiRequest('GET_PROFILE_RESPONSES', 'GET', {
      routeParams: {
        id: talentId,
      },
      query: {
        pageSize: 5,
        page: action?.page ?? 0,
      },
      authorization: 'optional',
    }));

    yield put({
      type: ActionTypes.profile.getResponses.SUCCESS,
      id: talentId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.profile.getResponses.ERROR,
      error,
    });
  }
}
export function* patchProfile(action) {
  const talentId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_PROFILE', 'PATCH', {
      routeParams: {
        id: talentId,
      },
      body: action?.body ?? [],
      query: {
        paginateResponses: 'true',
      },
    }));
    yield put({
      type: ActionTypes.profile.patch.SUCCESS,
      id: talentId,
      response,
    });
  } catch (error) {
    if (error?.status === 403 && !action?.retry) {
      yield put({
        type: ActionTypes.profile.patch.START,
        retry: true,
      });
    }

    yield put({
      type: ActionTypes.profile.patch.ERROR,
      error,
    });
  }
}

export function* putTalentNotes(action) {
  const talentId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('PUT_TALENT_NOTES', 'PUT', {
      routeParams: {
        id: talentId,
      },
      body: action?.body ?? [],
    }));
    yield put({
      type: ActionTypes.profile.putTalentNotes.SUCCESS,
      id: talentId,
      response,
    });
  } catch (error) {
    if (error?.status === 403 && !action?.retry) {
      yield put({
        type: ActionTypes.profile.putTalentNotes.START,
        retry: true,
      });
    }

    yield put({
      type: ActionTypes.profile.putTalentNotes.ERROR,
      error,
    });
  }
}
